"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
exports.SearchBoxMicrodata = ({ baseUrl, searchUrl, queryReplacement = 'search_term_string' }) => {
    const microdataObject = {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        url: baseUrl,
        potentialAction: {
            '@type': 'SearchAction',
            target: searchUrl,
            'query-input': `required name=${queryReplacement}`,
        },
    };
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, JSON.stringify(microdataObject))));
};
